export default "__VITE_ASSET__323b1d99__"